import * as React from 'react'
import { ColoredSpan } from '../../../../common/src/components/core'
import { ColorName } from '../../../../common/src/constants'

/**
 * User's shift status
 */
export enum Status {
  ON_BREAK,
  MISSING,
  // User doesn't have a shift but they are clocked in
  PROJECT,
  VIEWING,
  CLOCKED_IN,
  VIEWING_ALL,
}

interface StatusStringProps {
  status: Status
}

export function StatusString(props: StatusStringProps) {
  const { status } = props

  let color: ColorName | undefined
  let displayName = ''

  if (status === Status.PROJECT) {
    displayName = 'project'
  } else if (status === Status.ON_BREAK) {
    displayName = 'on break'
  } else if (status === Status.MISSING) {
    color = 'coral'
    displayName = 'missing'
  } else if (status === Status.VIEWING) {
    displayName = 'viewing'
  } else if (status === Status.CLOCKED_IN) {
    displayName = 'clocked in'
  } else if (status === Status.VIEWING_ALL) {
    displayName = 'viewing all'
  }

  return <ColoredSpan color={color}>{displayName}</ColoredSpan>
}
